// extracted by mini-css-extract-plugin
module.exports = {"redHederText":"competition_redHederText__v02WS","blueHederText":"competition_blueHederText__3sgKi","redText":"competition_redText__22w6U","blueText":"competition_blueText__3UyQw"};